import React, { useEffect, useState } from 'react';
import { Formio } from 'react-formio';
import { callEndpoint } from '../ApiCall'; // Make sure this function is correctly implemented
import LogoImage from '../images/logo.png'; // Adjust the path as necessary
import Footer from "../inc/footer";
// TEMPORARILY DISABLED: import useIframeAuth from "../hooks/useIframeAuth";

const getUrlParams = () => {
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const allParams = {};
    for (const [key, value] of params.entries()) {
      allParams[key] = value;
    }
    return allParams;
  };
const View = () => {
  // TEMPORARILY DISABLED: const { isAuthorized, isChecking } = useIframeAuth();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [formComponents, setFormComponents] = useState([]);
  const [submissionData, setSubmissionData] = useState(null);
  const params = getUrlParams();

  useEffect(() => {
    const fetchFormAndData = async () => {
      try {
        setLoading(true);
        const body = {
          col: ['form_data'],
          filter: [
            ['park', '=', '0'],
            ['form_type', '=', '1'],
            ['id', '=', params.id],
          ],
          table: params.table,
        };
        const endpoint = 'settingRoute.php';
        const action = 'getSetting';
        const response = await callEndpoint(body, endpoint, action);

        if (response && response.data && response.data.length > 0) {
          const parsedData = JSON.parse(response.data[0].form_data);
          // console.log(parsedData);
          setFormComponents(parsedData.components);
          setSubmissionData(parsedData.submission);
        } else {
          setFormComponents([]);
          setSubmissionData(null);
        }
      } catch (err) {
        console.error('Error fetching form data:', err);
        setError('Failed to load form data.');
      } finally {
        setLoading(false);
      }
    };

    fetchFormAndData();
  }, [params.id, params.table]);

  useEffect(() => {
    
  const renderForm = async () => {
    
    try {
      if (formComponents.length > 0) {
        // Apply the custom logic
        const formComponentsWithoutSubmitButton = formComponents.filter(
          (component) => component.type !== "button" || component.key !== "submit"
        );
        const formComponentsWithCustomLogic = formComponentsWithoutSubmitButton.map((component) => {
          if (component.type === "file") {
            return { ...component, disabled: false, customClass: "readonly hide-file-drop" }; // Allow file fields to be editable
          }
          if (component.type === "textarea") {
            // console.log("text true");
            return {
              ...component,
              attributes: {
                ...component.attributes, // Preserve existing attributes if any
                readonly: true, // Add the readonly attribute
              },
              customClass: "readonly-textarea", // Add a custom class for styling (optional)
            };
          }
          return { ...component, customClass: "readonly" }; // Disable other input types
        });

        console.log('Form Components with Custom Logic:', formComponentsWithCustomLogic);

        const formContainer = document.getElementById('formio-view');
        if (!formContainer) {
          console.error("Form container 'formio-view' not found");
          return;
        }

        const form = await Formio.createForm(formContainer, {
          components: formComponentsWithCustomLogic,
        });
        // 🎯 Intercept clicks on S3 links and open video modal
        formContainer.addEventListener(
          'click',
          (e) => {
            const link = e.target.closest('a');
            if (!link) return;

            const href = link.getAttribute('href');
            if (!href) return;

            // Check if this is an S3/AWS link
            if (href.includes('amazonaws.com') || href.includes('s3') || href.endsWith('.mp4')) {
              e.preventDefault();
              e.stopPropagation();
              e.stopImmediatePropagation();
              
              console.log('Opening video modal for:', href);
              
              // Extract file info and open video modal
              const fileName = link.textContent || href.split('/').pop() || 'video.mp4';
              const isVideo = href.endsWith('.mp4') || href.endsWith('.webm') || href.endsWith('.mov');
              const isImage = href.endsWith('.jpg') || href.endsWith('.jpeg') || href.endsWith('.png') || href.endsWith('.gif');
              
              // Determine file type
              let fileType = 'application/octet-stream';
              if (isVideo) fileType = 'video/mp4';
              else if (isImage) fileType = 'image/jpeg';
              
              // Extract key from URL
              let s3Key = '';
              try {
                const urlObj = new URL(href);
                s3Key = urlObj.pathname.substring(1); // Remove leading slash
              } catch (err) {
                s3Key = href.split('.amazonaws.com/')[1] || '';
              }
              
              // Build file object that matches what s3.js expects
              const fileObj = {
                name: fileName,
                url: href,
                key: s3Key,
                type: fileType,
                storage: 's3'
              };
              
              // Get S3 provider and call downloadFile
              const s3Provider = Formio.Providers.getProvider('storage', 's3');
              if (s3Provider) {
                const provider = s3Provider(Formio);
                provider.downloadFile(fileObj);
              } else {
                console.error('S3 storage provider not found');
              }
            }
          },
          true // capture phase
        );


        if (submissionData) {
          form.submission = { data: submissionData };
          await form.setSubmission(form.submission);
        }
      } else {
        console.log('No form components to render');
      }
    } catch (error) {
      console.error('Error rendering form:', error);
      setError('Failed to render the form.');
    }
  };

  renderForm();
}, [formComponents, submissionData]);


  return (
    <div className="app-container">
      <div>
        <img className="topCenter" src={LogoImage} alt="logo" />
      </div>
      <div>
        {loading && <div id="loader" className="loader"></div>}
        {!loading && error && (
          <div className="error-container">
            <h2>Error</h2>
            <p>{error}</p>
          </div>
        )}
        {!loading && formComponents.length === 0 && (
          <div className="no-data-container">
            <h2>No Form Found</h2>
          </div>
        )}
        {formComponents.length > 0 && (
          <div id="form-view" className="app-content" style={{ width: '100%', maxWidth: '800px', margin: '0 auto' }}>
            <div id="formio-view" />
          </div>
        )}
        <Footer />
      </div>
    </div>
  );
};

export default View;